function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState, forwardRef, useEffect } from 'react';
import { InputContainer, StyledInput, FloatingLabel, DescriptionText, ErrorMessage, CharacterCount } from './styles/input.styles';
/**
 * 기본 입력 필드 컴포넌트
 * 
 * 아토믹 디자인에서 원자(Atom) 레벨 컴포넌트
 */ var Input = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var className = _param.className, label = _param.label, description = _param.description, error = _param.error, _param_fullWidth = _param.fullWidth, fullWidth = _param_fullWidth === void 0 ? false : _param_fullWidth, _param_showCharacterCount = _param.showCharacterCount, showCharacterCount = _param_showCharacterCount === void 0 ? false : _param_showCharacterCount, maxLength = _param.maxLength, value = _param.value, placeholder = _param.placeholder, props = _object_without_properties(_param, [
        "className",
        "label",
        "description",
        "error",
        "fullWidth",
        "showCharacterCount",
        "maxLength",
        "value",
        "placeholder"
    ]);
    var _useState = _sliced_to_array(useState(false), 2), isFocused = _useState[0], setIsFocused = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), internalHasValue = _useState1[0], setInternalHasValue = _useState1[1];
    useEffect(function() {
        setInternalHasValue(value != null && value !== '');
    }, [
        value
    ]);
    var currentLength = typeof value === 'string' ? value.length : 0;
    // label이 있으면 placeholder를 숨김
    var inputPlaceholder = label ? '' : placeholder;
    return /*#__PURE__*/ React.createElement(InputContainer, {
        $fullWidth: fullWidth
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative',
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(StyledInput, _object_spread({
        className: className,
        $hasError: !!error,
        $fullWidth: fullWidth,
        $hasLabel: !!label,
        onFocus: function() {
            return setIsFocused(true);
        },
        onBlur: function() {
            return setIsFocused(false);
        },
        value: value,
        maxLength: maxLength,
        placeholder: inputPlaceholder,
        ref: ref
    }, props)), label && /*#__PURE__*/ React.createElement(FloatingLabel, {
        $focused: isFocused,
        $hasValue: internalHasValue,
        $hasError: !!error
    }, label, props.required && /*#__PURE__*/ React.createElement("span", {
        style: {
            color: 'var(--theme-error, #ef4444)',
            marginLeft: '0.2em'
        }
    }, "*"))), description && !error && /*#__PURE__*/ React.createElement(DescriptionText, null, description), error && /*#__PURE__*/ React.createElement(ErrorMessage, null, error), showCharacterCount && maxLength && /*#__PURE__*/ React.createElement(CharacterCount, {
        $hasError: !!error
    }, currentLength, " / ", maxLength));
});
Input.displayName = 'Input';
export default Input;
